<template>
  <div>
  <!-- <div class="footer-top hidden-md-and-up" v-if="$route.path === '/contact'">
    <v-layout row wrap justify-center>
      <v-flex xs12 md6 py-3 text-xs-center>
        <h2 class="display-1">Bezzina Group</h2>
        <p class="body-2">Level 1, 4-6 Kingsway, Cronulla, NSW 2230</p>
        <p class="body-2"><v-icon>{{ "fa fa-2x fa-phone" }}</v-icon> : 02 8556 8604</p>
        <p class="body-2"><v-icon>{{ "fa fa-2x fa-fax" }}</v-icon> : 02 9527 0493</p>
        <p class="body-2"><v-icon>{{ "fa fa-2x fa-envelope" }}</v-icon> :  info@bezzina.com.au</p>
      </v-flex>
      <v-flex xs12 md6 py-3 text-xs-center>
        <h2 class="display-1">Property &amp; Sales</h2>
        <p class="body-2"><v-icon>{{ "fa fa-2x fa-envelope" }}</v-icon> : sales@bezzina.com.au</p>
      </v-flex>
    </v-layout> 
  </div> -->
  <v-footer height="auto" class="grey darken-4 pa-3">
    <v-layout row wrap justify-center>
      <v-flex xs12 py-3 text-xs-center white--text>
        <a 
          v-for="(item, index) in socialLinks"
          :key="index"
          v-if='item.show'
          :href="item.link"
          target="_blank"
        >
        <v-btn
          icon
          class="fa dark small mx-3 white--text"
          color="grey darken-2"
        >
          <v-icon size="18">{{ item.icon }}</v-icon>
        </v-btn>
        </a>
      </v-flex>
      <v-btn
        class="hidden-sm-and-down"
        v-for="link in links"
        :key="link.name"
        color="white"
        flat
        small
        @click="$router.push(link.path)"
      >
        {{ link.name }}
      </v-btn>
      <v-flex xs12 py-3 text-xs-center white--text>
        <img src="https://cdnblobendpoint.azureedge.net/bezzina-static/img/bezzina-logo.png" id="footer-logo"></br>
        <CopyrightComponent/>
      </v-flex>
    </v-layout>
  </v-footer>
  </div>
</template>

<script>
import CopyrightComponent from './CopyrightComponent.vue'
import Api from '@/api'

export default {
  data: () => ({
    links: [{name: 'Home', path: '/'}, {name: 'About Us', path: '/about'}, {name: 'Experience', path: '/experience'}, {name: 'Works', path: '/works'}, {name: 'Design', path: '/design'}, {name: 'Contact Us', path: '/contact'}],
    // icons: [{class: 'fa fa-facebook', color: 'indigo'}, {class: 'fa fa-twitter', color: 'blue'}, {class: 'fa fa-linkedin', color: 'primary'}, {class: 'fa fa-instagram', color: 'purple'}],
    rows: [
      {
        title: 'Bezzina',
        children: ['Experience', 'Works', 'Design']
      }
    ],
    socialLinks: []
  }),
  components: {
    CopyrightComponent
  },
  beforeMount () {
    this.getSocialLinks()
  },
  methods: {
    getSocialLinks () {
      const path = '/social-links'
      const auth = {
        username: this.authUsername,
        password: this.authPassword
      }
      Api.get(path, auth)
        .then(response => {
          if (response.data.status === 0) {
            // console.log(response.data.about)
            // console.log(response.data.sociallinks)
            this.socialLinks = response.data.sociallinks
          } else {
            this.$swal(response.data.message)
          }
        })
        .catch(error => {
          this.$swal(error.toString().substring(0, 100))
        })
    }
  }
}
</script>

<style scoped>
/*.footer-top {
  font-family: 'Lato', sans-serif;
  background: #ccc;
  width: 100%;
  height: 30vw; 
  margin-bottom: 11vw;
  padding-top: 3.5vh;
}*/
footer {
  font-family: 'Lato', sans-serif;
  font-size: 9pt;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  margin-bottom: -175px;
  padding: 10px 0;
}
button {
  font-size: 9pt;
}
.body-2 {
  text-align: center;
}

@media screen and (max-width: 607px) {
  .footer-top {
    height: 70vh; 
    margin-bottom: 9vw;
  }
  #footer-logo {
    width: 35vmax;
  }
}

@media screen and (min-width: 608px) and (max-width: 959px) {
  .footer-top {
    height: 60vw; 
    margin-bottom: 7.7vw;
  }
  #footer-logo {
    width: 22vmax;
  }
}

@media screen and (min-width: 960px) {
  .footer-top {
    height: 30vw; 
    margin-bottom: 7.5vw;
  }
  #footer-logo {
    width: 18vmax;
  }
}

@media screen and (min-width: 1370px) {
  .footer-top {
    height: 20vw; 
    margin-bottom: 11vh;
    padding-top: 3.5vh;
  }
  #footer-logo {
    width: 15vmax;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/FooterComponent.vue